import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Search, AlertCircle, Unlock } from 'lucide-react';
import { useReleaseBooking } from './ReleaseBooking/useReleaseBooking';
import BookingCard from './ReleaseBooking/BookingCard';
import ConfirmReleaseDialog from './ReleaseBooking/ConfirmReleaseDialog';

export default function ReleaseBooking() {
  const {
    refInput, setRefInput, booking, searching, searchError,
    confirmOpen, setConfirmOpen, releasing,
    handleSearch, handleConfirmRelease,
  } = useReleaseBooking();

  return (
    <div className="space-y-6" data-testid="release-booking-page">
      <div className="flex items-center gap-2">
        <Unlock className="w-6 h-6 text-primary" />
        <h1 className="text-2xl font-bold">Release Booking</h1>
      </div>
      <p className="text-sm text-muted-foreground">
        Release a CONFIRMED + Paid + Future Dated booking to free its court slot immediately, without touching
        payment records. Search by booking reference below.
      </p>
      <p className="text-sm text-muted-foreground">
      No Refund Policy: Payments are non-refundable. If required, please follow up with customer to arrange for a manual complimentary replacement booking, subject to availability and management approval.
      </p>


      <form onSubmit={handleSearch} className="flex items-end gap-3 max-w-md">
        <div className="flex-1">
          <Label htmlFor="release-ref-input" className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Booking Reference
          </Label>
          <Input
            id="release-ref-input"
            placeholder="e.g. 34d4ec9a"
            value={refInput}
            onChange={(e) => setRefInput(e.target.value)}
            data-testid="release-ref-input"
          />
        </div>
        <Button type="submit" disabled={searching || !refInput.trim()} data-testid="release-search-button">
          <Search className="w-4 h-4 mr-2" />
          {searching ? 'Searching…' : 'Search'}
        </Button>
      </form>

      {searchError && (
        <div
          className="flex items-center gap-2 rounded-md border border-rose-200 bg-rose-50 px-3 py-2.5 text-sm text-rose-700 max-w-md"
          data-testid="release-search-error"
        >
          <AlertCircle className="w-4 h-4 shrink-0" />
          {searchError}
        </div>
      )}

      {booking && (
        <div className="max-w-xl">
          <BookingCard booking={booking} onReleaseClick={() => setConfirmOpen(true)} />
        </div>
      )}

      <ConfirmReleaseDialog
        booking={booking}
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        releasing={releasing}
        onConfirm={handleConfirmRelease}
      />
    </div>
  );
}
